import { useEffect, useRef, useState } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";

function KitchenSetup({ onConfigured }) {
  const html5QrCodeRef = useRef(null);
  const [cameras, setCameras] = useState([]);
  const [currentCameraIndex, setCurrentCameraIndex] = useState(0);
  const [cameraSupported, setCameraSupported] = useState(true);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [manualLocale, setManualLocale] = useState("");
const [manualError, setManualError] = useState("");
  // 📱 Rilevamento dispositivo
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;

  const shouldShowIOSInstallCard = isIOS && !isStandalone;
  const shouldShowAndroidBanner = false;

  // 🎥 Avvio scanner
  useEffect(() => {
    if (shouldShowIOSInstallCard) return;

    // 🔥 FIX ANDROID PWA: aspetta un attimo prima di avviare la camera
    const delay = isStandalone ? 500 : 0;

    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      setCameraSupported(false);
      return;
    }

    const qrRegionId = "qr-reader";

    html5QrCodeRef.current = new Html5Qrcode(qrRegionId);


  setTimeout(() => {
  Html5Qrcode.getCameras()
    .then(devices => {
      if (!devices || !devices.length) {
        console.warn("⚠️ Nessuna camera rilevata, provo fallback environment");
        startCamera({ facingMode: "environment" });
        return;
      }

      setCameras(devices);

      const backIndex = devices.findIndex(d =>
        (d.label || "").toLowerCase().includes("back") ||
        (d.label || "").toLowerCase().includes("rear") ||
        (d.label || "").toLowerCase().includes("posteriore")
      );

      const startIndex = backIndex !== -1 ? backIndex : 0;
      setCurrentCameraIndex(startIndex);

      startCamera(devices[startIndex].id);
    })
    .catch(err => {
      console.error("Errore accesso camera, provo fallback:", err);
      startCamera({ facingMode: "environment" });
    });
}, delay);

    return () => {
      if (html5QrCodeRef.current) {
        html5QrCodeRef.current.stop().catch(() => {});
      }
    };
  }, [shouldShowIOSInstallCard, isStandalone]);

  useEffect(() => {
    if (window.__KITCHEN_INSTALL_PROMPT) {
      setDeferredPrompt(window.__KITCHEN_INSTALL_PROMPT);
    }

    const syncPrompt = () => {
      if (window.__KITCHEN_INSTALL_PROMPT) {
        setDeferredPrompt(window.__KITCHEN_INSTALL_PROMPT);
      }
    };

    window.addEventListener("focus", syncPrompt);
    return () => window.removeEventListener("focus", syncPrompt);
  }, []);

const startCamera = (cameraConfig) => {
  html5QrCodeRef.current.start(
    cameraConfig,
    { fps: 10, qrbox: 250 },
    async (decodedText) => {
      try {
        const url = new URL(decodedText);
        const locale = (url.searchParams.get("locale") || "").trim();

        if (!locale) return;

        const localeRef = doc(db, "locali", locale);
        const localeSnap = await getDoc(localeRef);

        if (!localeSnap.exists()) {
          setManualError("❌ Codice locale errato");
          return;
        }

        console.log("🍳 Locale cucina:", locale);

        localStorage.setItem("kitchen_locale", locale);
        localStorage.setItem("kitchen_just_configured", "true");

        await html5QrCodeRef.current.stop();
        window.location.reload();
      } catch (err) {
        console.log("QR non valido", err);
        setManualError("❌ QR non valido");
      }
    },
    () => {}
  );
};

  const switchCamera = async () => {
    if (!cameras.length) return;

    const nextIndex = (currentCameraIndex + 1) % cameras.length;

    await html5QrCodeRef.current.stop();
    setCurrentCameraIndex(nextIndex);
    startCamera(cameras[nextIndex].id);
  };

  // 🍎 INSTALLAZIONE iOS
  if (shouldShowIOSInstallCard) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#0f0f12",
          padding: "1.5rem",
          color: "white"
        }}
      >
        <div
          style={{
            backgroundColor: "#1a1a1d",
            padding: "2rem",
            borderRadius: "22px",
            boxShadow: "0 20px 50px rgba(0,0,0,0.4)",
            maxWidth: "360px",
            width: "100%",
            textAlign: "center"
          }}
        >
          <div style={{ fontSize: "40px", marginBottom: "1rem" }}>👨‍🍳</div>

          <h3 style={{ marginBottom: "1rem" }}>
            Installa Cucina QrMenu
          </h3>

          <p style={{ fontSize: "0.95rem", color: "#bbb", marginBottom: "1.5rem" }}>
            Installa l’app e poi scansiona il QR per attivare le notifiche.
          </p>

          <div style={{ textAlign: "left", fontSize: "0.9rem", marginBottom: "1.5rem" }}>
            <div>1. Tocca <b>Condividi</b></div>
            <div>2. <b>Aggiungi a Home</b></div>
            <div>3. Apri l’app</div>
            <div>4. Inquadra il QR del locale oppure inserisci il codice manualmente</div>
          </div>

          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "12px",
              borderRadius: "12px",
              border: "none",
              backgroundColor: "#0a84ff",
              color: "#fff",
              cursor: "pointer",
              width: "100%"
            }}
          >
            Ho installato
          </button>
        </div>
      </div>
    );
  }

  // 📷 SCANNER
  return (
    <div style={{ padding: "2rem", textAlign: "center", color: "white" }}>




      {!cameraSupported ? (
        <div>
          <h3>❌ Fotocamera non disponibile</h3>
          <p>Apri in Chrome per configurare</p>
        </div>
      ) : (
        <>
          <h2 style={{ marginBottom: "0.5rem" }}>👨‍🍳 Configura Cucina</h2>

          <p style={{ opacity: 0.7, marginBottom: "1.5rem" }}>
            Inquadra il QR del locale
          </p>

          <div id="qr-reader" style={{ width: "300px", margin: "auto" }} />

          <div style={{ marginTop: "24px" }}>
  <p style={{ opacity: 0.6, fontSize: "0.9rem" }}>
    Se la fotocamera non si apre, inserisci il codice locale manualmente
  </p>

  <input
    value={manualLocale}
    onChange={(e) => setManualLocale(e.target.value)}
    placeholder="Codice locale"
    style={{
      padding: "12px",
      borderRadius: "10px",
      border: "1px solid rgba(255,255,255,0.2)",
      background: "#111",
      color: "#fff",
      width: "260px",
      maxWidth: "90%",
      textAlign: "center"
    }}
  />

  <br />

  <button
  onClick={async () => {
  const locale = manualLocale.trim();
  if (!locale) return;

  setManualError("");

  try {
    const localeRef = doc(db, "locali", locale);
    const localeSnap = await getDoc(localeRef);

    if (!localeSnap.exists()) {
      setManualError("❌ Codice locale errato");
      return;
    }

    localStorage.setItem("kitchen_locale", locale);
    localStorage.setItem("kitchen_just_configured", "true");
    window.location.reload();
  } catch (err) {
    console.error(err);
    setManualError("❌ Errore verifica codice locale");
  }
}}
  >
    Configura manualmente
  </button>

  {manualError && (
    <div
      style={{
        marginTop: "12px",
        color: "#ff6b6b",
        fontSize: "0.9rem",
        fontWeight: 600
      }}
    >
      {manualError}
    </div>
  )}
</div>

          {cameras.length > 1 && (
            <button
              onClick={switchCamera}
              style={{
                marginTop: "20px",
                padding: "10px 20px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: "#0a84ff",
                color: "white",
                cursor: "pointer"
              }}
            >
              🔄 Cambia fotocamera
            </button>
          )}
        </>
      )}
    </div>
  );
}

export default KitchenSetup;